import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Theme,
  Typography,
} from '@freighthub/silhouette-core'
import { inject } from 'mobx-react'
import { useObserver } from 'mobx-react-lite'
import { FC } from 'react'
import { FAQService } from 'service/FAQService'
import { useI18n } from 'utils/localisation'

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  question: {
    '&:not(:last-of-type)': {
      paddingBottom: spacing(4),
    },
  },
}))

interface QuestionInterface {
  question: string
  answer: string
  short?: string
}

const Question: FC<{ question: QuestionInterface }> = ({ question }) => {
  const classes = useStyles()

  return (
    <div className={classes.question}>
      <Typography variant="subtitle1">{question.question}</Typography>
      <div dangerouslySetInnerHTML={{ __html: question.answer }} />
    </div>
  )
}

interface FAQDialogProps {
  faqService?: FAQService
}

export const FAQDialog: FC<FAQDialogProps> = inject('faqService')(({ faqService }) => {
  const { translate } = useI18n()
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const category = translate(`faq-category-${faqService.category}`)
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const questions = faqService.questions.map((question) => ({
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    question: translate(`faq-${faqService.category}-${question}-question`),
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    answer: translate(`faq-${faqService.category}-${question}-answer`),
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    short: translate(`faq-${faqService.category}-${question}-short`),
  }))

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  if (!questions.length && faqService.category) {
    throw new Error(
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-trailing-spaces
      `No text was found for category: ${
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        faqService.category
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      } and questions: ${faqService.questions.join(', ')}`
    )
  }

  return useObserver(() => (
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    <Dialog open={faqService.isOpen} onClose={faqService.close} maxWidth="md">
      <DialogTitle>{category}</DialogTitle>
      <DialogContent>
        {questions.map((question) => (
          <Question question={question} />
        ))}
      </DialogContent>
      <DialogActions>
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        <Button onClick={() => faqService.close()}>{translate('fbaPremium-intro-toc-close')}</Button>
      </DialogActions>
    </Dialog>
  ))
})
